@if (documentID) {
  <button (click)="downloadDocument()" mat-flat-button [matTooltip]="'common.buttons.download' | transloco"
    matTooltipClass="reghub-tooltip" [attr.aria-label]="'common.labels.downloadDocument' | transloco" color="accent"
    data-testid="document-download-button">
    <mat-icon>description</mat-icon>
    <mat-label>{{ documentName }}</mat-label>
  </button>
}